function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M68.29,68.29v363.421c0,20.078,16.264,36.34,36.343,36.34h304.363  c12.536,0,22.716-10.175,22.716-22.711c0-12.541-10.18-22.716-22.716-22.716H131.889c-9.996,0-18.17-8.18-18.17-18.172  c0-9.987,8.175-18.168,18.17-18.168h263.478c20.078,0,36.345-16.267,36.345-36.346V68.29c0-20.077-16.267-36.34-36.345-36.34  H268.172v163.45c0,2.36-0.905,4.719-2.636,6.538c-3.538,3.54-9.362,3.54-12.902,0c-2.363-2.457-38.976-32.89-38.976-32.89  s-36.612,30.433-38.977,32.89c-3.54,3.54-9.359,3.54-12.901,0c-1.725-1.819-2.635-4.178-2.635-6.538V31.949h-54.512  C84.553,31.949,68.29,48.213,68.29,68.29z",
  fill: "#7b2133",
  fillRule: "evenodd"
});

var SvgBookmarkList = function SvgBookmarkList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "Layer_1",
    viewBox: "0 0 500 500",
    width: "32px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmarkList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark-list.f1346947.svg";
export { ForwardRef as ReactComponent };